/** Copied from src/client/components/OfferPage/AlwaysOn/AlwaysOnStickyHeader.tsx walled content login & signup buttons */
import { accountAccessShowLogin } from 'actions/UiActions'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useAppDispatch } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-inline-start: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-end;
  }
`

const AuthButtonsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-inline-start: ${rem(8)};
  }
`

const MobileNewLine = styled.br`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`
export default function GenericLoginSignupWall() {
  const authDispatch = useAppDispatch()

  return (
    <InlineWrapper>
      <BodyText weight="bold" variant="small">
        <FormattedMessage
          id="YO7HwmVobZe-ni9uw1-n"
          defaultMessage="Join now to view {mobileNewLine} member prices"
          description="Heading text encouraging users to join to see member prices"
          values={{ mobileNewLine: <MobileNewLine /> }}
        />
      </BodyText>
      <AuthButtonsWrapper>
        <TextButton kind="secondary" onClick={() => authDispatch(accountAccessShowLogin())}>
          <FormattedMessage
            id="aZz53WkzHKUmsr5bfF5y"
            defaultMessage="Log In"
            description="Action button label to navigate to the login page or open the login modal"
          />
        </TextButton>
        <TextButton kind="primary" onClick={() => authDispatch(accountAccessShowLogin())}>
          <CSSBreakpoint max="mobile" as="span">
            <FormattedMessage
              id="NyMteGmwLlwFj1o0OSCG"
              defaultMessage="Sign up"
              description="Mobile button label prompting a visitor to create a free member account"
            />
          </CSSBreakpoint>
          <CSSBreakpoint min="tablet" as="span">
            <FormattedMessage
              id="oyGLdH3-OJAZvWjjYz_d"
              defaultMessage="Sign up for free"
              description="Tablet and desktop button label prompting a visitor to create a free member account"
            />
          </CSSBreakpoint>
        </TextButton>
      </AuthButtonsWrapper>
    </InlineWrapper>
  )
}
